import React from "react";
import pluralize from "pluralize";
import PropTypes from "prop-types";
import { ACCESS_TIERS } from "constants";
import { useAccessTier } from "contexts/AccessTierContext";
import FreeTierModalLink from "./shared/AIForm/FreeTierModalLink";

const BannerContent = ({ signupPath, quotaRemaining, resetDate }) => {
  const { accessTier } = useAccessTier();

  switch (accessTier) {
    case ACCESS_TIERS.SIGNED_OUT:
      return (
        <FreeTierModalLink
          amplitudeKey="standaloneFreeTierInfoBanner"
          buttonText="Get 1 free answer"
        />
      );
    case ACCESS_TIERS.FREE:
      return (
        <span>
          {quotaRemaining} left (
          <a data-amplitude="standaloneFreeToPaidInfoBanner" href={signupPath}>
            Get 250 answers per month
          </a>
          )
        </span>
      );
    case ACCESS_TIERS.A_PLUS:
    case ACCESS_TIERS.A_PLUS_TEACHER:
      return (
        <span>
          {pluralize("answers", quotaRemaining, true)} left (resets on{" "}
          {resetDate}){" "}
        </span>
      );
    default:
      return null;
  }
};

const InfoBanner = ({ signupPath, quotaRemaining, resetDate }) => (
  <div
    className="ai-form--banner lc-banner lc-banner-information"
    data-testid="ai-form-banner"
  >
    <BannerContent
      signupPath={signupPath}
      quotaRemaining={quotaRemaining}
      resetDate={resetDate}
    />
  </div>
);

InfoBanner.propTypes = {
  quotaRemaining: PropTypes.number.isRequired,
  resetDate: PropTypes.string,
  signupPath: PropTypes.string
};

InfoBanner.defaultProps = {
  resetDate: "",
  signupPath: "/sign-up?focus=teacher"
};

export default InfoBanner;
